<!-- 通用行标头，传入标题，点击更多操作 -->
<template>
  <div class="common_title" :style="showBorder ? `border-bottom:1px dashed #bdd4e8` : ''" >
    <div class="common_title_inner flex jc_sb">
      <div class="title flex" :style="{ fontSize: fontSize }">
        <div class="line" :style="{ background: barBgc }" v-if="showLine"></div>
        {{ title }}
      </div>
      <img v-if="showMore" class="pointer" src="../assets/imgs/home/more.png" title="更多" @click="moreClick" />
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonCommonTitle",
  props: {
    title: {
      type: String,
      default: "请传入一个title",
    },
    barBgc: {
      type: String,
      default: "#1E3C63",
    },
    showLine: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: "20px",
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    moreClick() {
      this.$emit("moreClick");
    },
  },
};
</script>
<style lang="less" scoped>
.common_title {
  padding-bottom: 20px;
}
.common_title_inner {
  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #1E3C63;
    line-height: 21px;
    .line {
      width: 3px;
      height: 24px;
      margin-right: 12px;
    }
  }
}
</style>